interface Props {
  className?: string;
  height?: number;
}

/** Placeholder shown while chart data is loading. */
const ChartSkeleton = ({ className, height = 360 }: Props) => {
  return (
    <div
      className={`w-full animate-pulse rounded border border-gray-100 bg-white p-3 ${className || ""}`}
      style={{ minHeight: height }}
      aria-busy="true"
      aria-label="در حال بارگذاری نمودار"
    >
      {/* legend */}
      <div className="mb-3 flex justify-center gap-3">
        <div className="h-2.5 w-2.5 rounded-sm bg-gray-200" />
        <div className="h-2.5 w-40 rounded bg-gray-200" />
      </div>

      <div className="flex gap-2" style={{ height: height - 120 }}>
        {/* Y axis ticks */}
        <div className="flex w-8 flex-col justify-between py-2">
          <div className="h-2 w-full rounded bg-gray-200" />
          <div className="h-2 w-full rounded bg-gray-200" />
          <div className="h-2 w-full rounded bg-gray-200" />
          <div className="h-2 w-full rounded bg-gray-200" />
        </div>

        {/* plot area with fake line */}
        <div className="relative flex-1 overflow-hidden rounded bg-gray-50">
          <div className="absolute inset-x-0 top-1/4 h-px bg-gray-200" />
          <div className="absolute inset-x-0 top-2/4 h-px bg-gray-200" />
          <div className="absolute inset-x-0 top-3/4 h-px bg-gray-200" />
          <svg
            className="absolute inset-0 h-full w-full"
            viewBox="0 0 400 200"
            preserveAspectRatio="none"
          >
            <path
              d="M0 120 C 40 80, 80 140, 120 100 S 200 40, 240 90 S 320 160, 360 110 S 400 70, 400 70"
              fill="none"
              stroke="#e5e7eb"
              strokeWidth="3"
              vectorEffect="non-scaling-stroke"
            />
            {[40, 100, 160, 220, 280, 340].map((x, i) => (
              <circle
                key={x}
                cx={x}
                cy={[100, 90, 70, 110, 95, 85][i]}
                r="4"
                fill="#e5e7eb"
              />
            ))}
          </svg>
        </div>
      </div>

      {/* X axis labels */}
      <div className="mt-3 flex justify-between px-10">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="h-10 w-2 rounded bg-gray-200" />
        ))}
      </div>
    </div>
  );
};

export default ChartSkeleton;
